module.exports = __webpack_public_path__ + "static/media/login-desktop-bg.aea39bd3.svg";